import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/user/job-experience', {params});
  },
  detail(id: string | number) {
    return axios.get(`/user/job-experience/${id}`);
  },
  update(id: string | number, payload = {}) {
    return axios.put(`/user/job-experience/${id}`, payload);
  },
  delete(id: string | number) {
    return axios.delete(`/user/job-experience/${id}`);
  },
  create(payload = {}) {
    return axios.post(`/user/job-experience`, payload);
  },
};
